import styled from "styled-components";

export const Card = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 600px;
  margin: 24px auto;
`;

export const Header = styled.h2`
  font-size: 20px;
  color: #333;
  text-align: center;
  margin-bottom: 16px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #ddd;
`;

export const Label = styled.span`
  font-weight: bold;
  color: #444;
`;

export const Value = styled.span`
  color: #666;
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
`;

export const Button = styled.button`
  background-color: ${(props) =>
    props.color === "secondary" ? "#dc3545" : "#16b875"};
  color: white;
  border: none;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) =>
    props.color === "secondary" ? "#c82333" : "#45c18d"};
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  width: 400px;
`;

export const ModalTitle = styled.h3`
  margin-bottom: 16px;
`;

export const Text = styled.p`
  font-size: 14px;
  margin-bottom: 20px;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ConfirmButton = styled(Button)`
  background-color:#16b875;

  &:hover {
    background-color:#45c18d;
  }
`;

export const CancelButton = styled(Button)`
  background-color: #6c757d;

  &:hover {
    background-color: #5a6268;
  }
`;
